import React, { useState } from 'react'
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";



const Contact = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setClass] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const classChange = (e) => {
        const value = e.target.value;
        setClass(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(

                // "service_6cmauvs",
                // "template_x1km55n",
                // "#myForm",
                // "UxSCvEKScVZiA635l"

                "service_v21280q",
                "template_p3pr7g2",
                "#myForm",
                "VM_2a1DQVeN5Zu6lr"

            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setClass("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>

            <div style={{ overflow: "hidden" }}>
                <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                    <div className="container">
                        <div className="row">
                            <div className="page-heading">
                                <h2 className="wow fadeInUp" data-wow-delay=".3s">Contact Us</h2>
                                <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li><i className="fa-solid fa-chevron-right" /></li>
                                    <li>Contact Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="contact-section-2 section-padding fix">
                    <div className="container">
                        <div className="contact-us-wrapper">
                            <div className="row g-4">
                                <div className="col-lg-5">
                                    <div className="contact-box-item">
                                        <h3>Office Information</h3>
                                        <div className="contact-info-items wow fadeInUp" data-wow-delay=".3s">
                                            <div className="icon">
                                                <i className="fa-solid fa-phone" />
                                            </div>
                                            <div className="content">
                                                <p>Call anytime</p>
                                                <h4>
                                                    <a href="tel:+91 7000664954">+91 7000664954</a><br />
                                                    <a href="tel:+91 6265386826">+91 6265386826</a>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="contact-info-items wow fadeInUp" data-wow-delay=".5s">
                                            <div className="icon">
                                                <i className="fa-solid fa-square-chevron-down" />
                                            </div>
                                            <div className="content">
                                                <p>Email address</p>
                                                <h4>
                                                    <a href="mailto:svpsatna@gmail.com" style={{ fontSize: "" }}>svpsatna@gmail.com</a>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="contact-info-items wow fadeInUp" data-wow-delay=".7s">
                                            <div className="icon">
                                                <i className="fa-solid fa-clock" />
                                            </div>
                                            <div className="content">
                                                <p>Opening Time</p>
                                                <h4>
                                                    09:00 AM – 05:00 PM
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="contact-content">
                                        <h3 className="wow fadeInUp" data-wow-delay=".3s">Drop Message</h3>
                                        <p>
                                        </p>
                                        <p className="wow fadeInUp" data-wow-delay=".5s">
                                            Fill in your details and we’ll call you back.
                                        </p>
                                        <form method="POST" onSubmit={sendEmail} id="myForm" className="contact-form-items">
                                            <div className="row g-4">
                                                <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                                    <div className="form-clt">
                                                        <input type="text" placeholder="Your name"
                                                            name="from_name"
                                                            onChange={(e) => nameChange(e)}
                                                            required
                                                            value={name}
                                                            id="name"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                                                    <div className="form-clt">
                                                        <input type="text" placeholder="Your email"
                                                            id="email"
                                                            name='email'
                                                            onChange={(e) => mailChange(e)}
                                                            value={mail}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 wow fadeInUp" data-wow-delay=".7s">
                                                    <div className="form-clt">
                                                        <input type="number" placeholder="Phone Number"
                                                            id="phone"
                                                            name='phone'
                                                            onChange={(e) => numberChange(e)}
                                                            value={number}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-lg-6 wow fadeInUp" data-wow-delay=".7s">
                                                    <div className="form-clt">
                                                        <input type="text" placeholder="Class"
                                                            name="class"
                                                            id="class"
                                                            onChange={(e) => classChange(e)}
                                                            value={class}
                                                            required
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                                    <div className="form-clt">
                                                        <textarea placeholder="Message Here"
                                                            id="address"
                                                            onChange={(e) => massagesChange(e)}
                                                            name='massage'
                                                            value={massages}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 wow fadeInUp" data-wow-delay=".3s">
                                                    {/* <a to='/' type="submit" className="theme-btn">
                                                        Send Message
                                                    </a> */}

                                                    <button type="submit" className="theme-btn">Send A Message</button>


                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                {/* Map-section Start */}
                <div className="map-section" style={{ marginTop: "-80px" }}>
                    <div className="map-items">
                        <div className="googpemap">
                            <div className="mapouter container"><div className="gmap_canvas"><iframe className="gmap_iframe" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1100&height=300&hl=en&q=Saraswati Awasiya Shikha School, HV68+MJX, Maihar Bypass Rd, Delaura, RamTekri, Satna, Madhya Pradesh 485113&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google map embed html</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:1100px;height:300px;}.gmap_canvas {overflow:hidden;background:none!important;width:1100px;height:300px;}.gmap_iframe {width:1100px!important;height:300px!important;}" }} /></div>



                            {/* <div className='container' style={{ textDecoration: 'none', overflow: 'hidden', maxWidth: '100%', width: 1100, height: 300 }}><div id="canvas-for-googlemap" style={{ height: '100%', width: '100%', maxWidth: '100%' }}><iframe style={{ height: '100%', width: '100%', border: 0 }} frameBorder={0} src="https://www.google.com/maps/embed/v1/place?q=SARASWATI+VIDYAPEETH+HR+SEC+SCHOOL+UTAILI+SATNA&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" /></div><a className="from-embedmap-code" rel="nofollow" href="https://www.bootstrapskins.com/themes" id="grab-map-data">premium bootstrap themes</a><style dangerouslySetInnerHTML={{ __html: "#canvas-for-googlemap img{max-height:none;max-width:none!important;background:none!important;}" }} /></div> */}
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />

        </>
    )
}

export default Contact